import { render } from "./ProformaStaffCard.vue?vue&type=template&id=0c0197e4"
import script from "./ProformaStaffCard.vue?vue&type=script&lang=js"
export * from "./ProformaStaffCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__